import { selectUserProject } from 'core/userContext/selectors';
import { useSelector } from 'react-redux';
import { InputText } from 'ui/inputs';
import { CloneJourneyProjectSelect } from './CloneJourneyProjectSelect';
import { useCloningCampaignsContext } from './context';

import { CLONE_JOURNEY_INPUT_TEST_ID } from './constants';

export const CloneJourney = () => {
  const currentProject = useSelector(selectUserProject);
  const {
    campaignNodes,
    copyCampaigns,
    setCopyCampaigns,
    copyWebhooks,
    setCopyWebhooks,
    selectedProject,
    wfNameInput,
    setWorkflowNameInput,
    setSelectedProject,
  } = useCloningCampaignsContext();

  return (
    <>
      <span>New journey name</span>
      <InputText
        id="journey-name"
        data-test={CLONE_JOURNEY_INPUT_TEST_ID}
        value={wfNameInput}
        onChange={setWorkflowNameInput}
      />

      <CloneJourneyProjectSelect
        setSelectedProject={setSelectedProject}
        currentProject={currentProject}
        selectedProject={selectedProject}
        setCopyCampaigns={setCopyCampaigns}
        copyCampaigns={copyCampaigns}
        setCopyWebhooks={setCopyWebhooks}
        copyWebhooks={copyWebhooks}
        campaignNodes={campaignNodes}
      />
    </>
  );
};
